<template>
  <a-upload
    v-model:file-list="fileList"
    :showUploadList="false"
    :maxCount="1"
    :before-upload="beforeUpload"
    :custom-request="customRequest"
    :accept="props.types.join(',')"
  >
    <div class="flex padding-30" v-if="loading"><a-spin size="small" /></div>
    <template v-else-if="props.value">
      <img :src="props.value" alt="" />
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </a-upload>
</template>

<script setup>
import { ref } from 'vue'
import { Spin as ASpin, Upload as AUpload, Form as AForm, message } from 'ant-design-vue'
// import * as XLSX from 'xlsx'
import { uploadFile } from '@/service/api/app'

const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  types: {
    type: Array,
    default: () => []
  },
  maxSizeMB: {
    type: Number,
    default: 1
  },
  bizType: {
    type: String,
    default: 'TEXT'
  }
})
const emits = defineEmits(['update:value'])
const formItemContext = AForm.useInjectFormItemContext()

const fileList = ref([])
const loading = ref(false)
const beforeUpload = (file) => {
  let typeBol = true
  let sizeBol = true
  if (!props.types.includes(file.type)) {
    message.error('上传文件格式错误！')
    typeBol = false
  }
  if (file.size > props.maxSize * 1024 * 1024) {
    message.error(`文件大小不能超过 ${props.maxSize}MB！`)
    sizeBol = false
  }
  return typeBol && sizeBol
}
const customRequest = (file) => {
  let data = new FormData()
  data.append('file', file.file)
  data.append('bizType', 'IMAGE')
  loading.value = true
  uploadFile(data).then((res) => {
    if (res.data) {
      emits('update:value', res.data.dataUrlManage)
      loading.value = false
      formItemContext.onFieldChange()
    }
  })
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  max-height: 150px;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 6px;
}
</style>
